import { render } from "./EventInfo.vue?vue&type=template&id=0bc499d9&scoped=true"
import script from "./EventInfo.vue?vue&type=script&lang=js"
export * from "./EventInfo.vue?vue&type=script&lang=js"

import "./EventInfo.vue?vue&type=style&index=0&id=0bc499d9&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bc499d9"]])

export default __exports__